import { render } from "./AtividadeListDialog.vue?vue&type=template&id=1aa31fca"
import script from "./AtividadeListDialog.vue?vue&type=script&lang=js"
export * from "./AtividadeListDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__